export enum CardEventType {
    cardAdded,
    cardUpdated,
    cardDeleted,
    cardsAdded,
    cardsDeleted,
}
